var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-auto",attrs:{"color":"primary","elevation":"5","x-large":"","disabled":_vm.disabled},on:{"click":_vm.onSubmit}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }